var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 50,
    viewBox: "0 0 57 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1276 0.000274658L28.6614 11.547L22.1953 0.000274658H0.662109L28.6614 49.9998L56.6607 0.000274658H35.1276Z",
    fill: "#C18CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.127 0.000411987L28.6609 11.5472L22.1948 0.000411987H11.8613L28.6609 29.9995L45.4605 0.000411987H35.127Z",
    fill: "#8A49D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 50,
    fill: "white",
    transform: "translate(0.664062)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.9eb60d684f09c288919db00066d28379.svg";
export { ForwardRef as ReactComponent };